var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FaceBook"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5168 0.5H2.36354C1.89131 0.5 1.43843 0.681769 1.10451 1.00532C0.770599 1.32887 0.583008 1.7677 0.583008 2.22527L0.583008 18.7747C0.583008 19.2323 0.770599 19.6711 1.10451 19.9947C1.43843 20.3182 1.89131 20.5 2.36354 20.5H11.4363V12.5275H9.2305V9.63187H11.459V8.53297C11.459 7.52198 11.4023 5.94505 12.7349 4.68681C13.2325 4.24118 13.8215 3.90221 14.4634 3.69203C15.1053 3.48185 15.7858 3.40518 16.4604 3.46703H18.0481V6.43956C18.0481 6.43956 16.5284 6.1978 15.7402 6.57692C15.3963 6.77615 15.1175 7.06547 14.936 7.41154C14.7544 7.75761 14.6774 8.14635 14.7139 8.53297V9.63187H18.0481V12.5275H14.7139V20.5H19.5168C19.9885 20.4986 20.4405 20.3163 20.7741 19.9931C21.1077 19.6698 21.2958 19.2318 21.2973 18.7747V2.22527C21.2958 1.76815 21.1077 1.33016 20.7741 1.00692C20.4405 0.683684 19.9885 0.501449 19.5168 0.5",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceBook);
export default __webpack_public_path__ + "static/media/FaceBook.2ef18188.svg";
export { ForwardRef as ReactComponent };